import {Component, Input} from "@angular/core";
import {AlertController} from "ionic-angular";

@Component({
  selector: "item-description",
  templateUrl: "item-description.html",
})
export class ItemDescription {

  private static videoJsLoader: Promise<any>;

  @Input() item: any;
  activeTab: number = 0;
  samples = null;

  ngOnInit() {
    if (this.item.samples) {
      this.samples = JSON.parse(this.item.samples);
    }
  }

  playVideo(url) {
    if (!url) {
      return;
    }

    this.alertCtrl
      .create({
        cssClass: "video-modal",
        enableBackdropDismiss: true,
        message: `<video class="video-js" controls autoplay preload><source src="${url}" type="video/mp4"></video>`,
        buttons: [
          {
            text: "关闭",
          },
        ],
      })
      .present()
      .then(() => this.loadVideoJs())
      .then(() => {
        // Ionic inserts the alert content on the next tick.
        setTimeout(() => this.initializeVideoPlayer(), 0);
      })
      .catch((error) => console.error("Unable to load video player", error));
  }

  private loadVideoJs(): Promise<any> {
    if (window["videojs"]) {
      return Promise.resolve(window["videojs"]);
    }
    if (ItemDescription.videoJsLoader) {
      return ItemDescription.videoJsLoader;
    }

    ItemDescription.videoJsLoader = new Promise((resolve, reject) => {
      const css = document.createElement("link");
      css.rel = "stylesheet";
      css.href = "assets/vendor/videojs-7.10.2.css";
      document.head.appendChild(css);

      const script = document.createElement("script");
      script.src = "assets/vendor/videojs-7.10.2.js";
      script.async = true;
      script.onload = () => resolve(window["videojs"]);
      script.onerror = reject;
      document.body.appendChild(script);
    });
    return ItemDescription.videoJsLoader;
  }

  private initializeVideoPlayer() {
      const videoElement = document.getElementsByClassName("video-modal")[0].getElementsByTagName("video")[0];
      if (!videoElement) {
        return;
      }
      const player = window['videojs'](videoElement, {autoplay: true});
      player.height(300);

      const videoJsDiv = document.getElementsByClassName("video-modal")[0].getElementsByClassName("video-js")[0];
      let lastWidth = 0;
      const intervalId = setInterval(() => {
        const width = videoJsDiv.getBoundingClientRect().width;
        if (lastWidth === width) {
          clearInterval(intervalId);
          player.height(width * videoElement.videoHeight / videoElement.videoWidth);
          player.play();
        }
        lastWidth = width;
      }, 100)
  }

  constructor(
    private alertCtrl: AlertController,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/components/item-description/item-description.ts